import { initMap } from 'allink-core-static/js/modules/map';

$(function(){

    var options = {
        map_styles: [],
    };

    initMap(options);

    $(window).on('softpage:opened', function() {
        initMap(options);
    });

});



// WEBPACK FOOTER //
// ./static/js/modules/map.js